<div class="h-full flex overflow-hidden">
  <app-sidebar class="h-full overflow-hidden shadow-lg shadow-gray-300 " />
  <main class="h-full flex-1 overflow-auto main-content">
    <router-outlet />
  </main>
</div>

